import { addInbound, allInbounds, deleteInbound, updateInbound } from '@/utils/request'
import vue from '@/main'

const state = {
  inboundList: []
}

const mutations = {
  RESET (state) {
    state.inboundList = []
  }
}

const actions = {
  all ({ state }) {
    return new Promise((resolve) => {
      allInbounds().then(response => {
        state.inboundList = response.data
        resolve(state.inboundList)
      })
    })
  },
  inboundById ({ commit, state }, id) {
    for (const team of state.inboundList) {
      if (team.id === id) return vue.$_.cloneDeep(team)
    }
    return null
  },
  updateOne ({ state }, inbound) {
    return new Promise((resolve) => {
      updateInbound(inbound).then(() => {
        for (const cur of state.inboundList) {
          if (cur.id === inbound.id) {
            Object.assign(cur, inbound)
            break
          }
        }
        resolve()
      })
    })
  },
  add ({ commit, dispatch, state }, item) {
    return new Promise((resolve) => {
      addInbound(item).then((response) => {
        state.inboundList.push(response.data)
        resolve(response.data)
      })
    })
  },
  delete ({ commit, dispatch, state }, id) {
    return new Promise((resolve) => {
      deleteInbound(id).then(() => {
        for (const i in state.inboundList) {
          if (state.inboundList[i].id === id) {
            state.inboundList.splice(i, 1)
          }
        }
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
